<!-- 編輯按鈕(多項選擇) -->
<template>

  <v-menu :nudge-width="50"
          offset-y
          :nudge-top="0"
          :nudge-bottom="0"
          :nudge-left="50"
          v-bind="$attrs">
    <template v-slot:activator="{ on }">
      <v-btn dark style="padding:10px;margin:5px"
             :disabled="disabled"
             v-on="on"> {{btnText}}
      </v-btn>
    </template>
    <v-list>
      <!-- <v-list-tile
                   @click="closeMenu">
        <v-list-tile-title>取消</v-list-tile-title>
      </v-list-tile> -->
      <v-list-tile v-for="(item, key) in actionItems"
                   :key="key"
                   @click="actionHandler(item.action)">
        <v-list-tile-title>{{item.text}}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>
<script>
import { map } from 'lodash'
export default {
  name: 'base-edit-btn',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: '編輯'
    },
    actions: {
      type: Object,
      default: function () {
        return {
          preview: true,
          copy: false,
          edit: false,
          upload: false,
          delete: false,
          download: false
        }
      }
    },
    actionTexts: {
      type: Object,
      default: function () {
        return {
          preview: '檢視',
          copy: '複製',
          edit: '修改',
          upload: '上傳',
          delete: '刪除',
          download: '下載同意書',
          consentDownload: '同意書下載',
          jumpApp: '跳轉保險公司',
          reSent : '檢核資料重送',
          interview : '回填電訪結果',
          moneyLaund: '洗防資料重送',
          //eddDownload: 'EDD表單下載', //fix: SCR #89564 , 將 「EDD表單下載」  功能移除!
          writSendDate: '回填寄件日期',
          writtenDownload: '書面分析下載',
          writtenReSend: '重寄書面分析'
        }
      }
    }
  },

  computed: {
    actionItems () {
      let items = []
      const { actions, actionTexts } = this
      items = map(actions, (v, k) => {
        if (v) {
          return { action: k, text: actionTexts[k] }
        }
      }).filter(s => { return (s) })
      return items
    }
  },
  methods: {
    actionHandler (action) {
      this.$emit(`action-${action}`)
    }
    // ,
    // closeMenu() {
    //   return false
    // }
  }
}
</script>
<style lang="stylus" scoped>
.v-btn {
  background-color: $primary-color !important;
  min-width: auto !important;
  height: $height !important;
}

.v-list {
  padding-left: 0px;
  border-radius: 10px;
}

.v-list:hover {
  cursor: pointer;
}

.v-menu__content {
  border-radius: 15px;
  color: $gray;
}

.v-list div+div {
  border-top: 1px solid $gray;
}

.v-list div:hover {
  color: $primary-color;
}
</style>
